const mutations = {
  setEvents(state, payload) {
    state.events = payload;
  },
  setEventTypes(state, payload) {
    state.eventTypes = payload;
  },
  addEvent(state, payload) {
    state.events.push(payload);
  },
  updateEvent(state, payload) {
    Object.keys(payload).map((key, index) => {
      state.event[key] = payload[key];
    });
  },
  deleteEvent(state, payload) {
    state.events = state.events.filter(event => {
      return event.id !== payload;
    });
  },
  setEvent(state, payload) {
    payload.users = undefined;
    payload.files = undefined;
    state.event = payload;
  },
  setEventID(state, payload) {
    state.event.id = Number(payload);
  },
  setEventSkills(state, payload) {
    state.eventSkills = payload;
  },
  setEventFiles(state, payload) {
    state.eventFiles = payload;
  },
  setEventUsers(state, payload) {
    state.eventUsers = payload;
  },
  setEventTransfers(state, payload) {
    state.eventTransfers = payload;
  },
  addSkillToEvent(state, payload) {
    state.eventSkills.push(payload);
  },
  deleteSkillFromEvent(state, payload) {
    state.eventSkills = state.eventSkills.filter(skill => {
      return skill.id !== payload;
    });
  },
  addUserToEvent(state, payload) {
    state.event.users.push(payload);
  },
  deleteUserFromEvent(state, payload) {
    state.event.users = state.event.users.filter(user => {
      return user.id !== payload;
    });
  },
  setEmployees(state, payload) {
    state.eventEmployees = payload;
  },
  setEmployeesFndIDFilter(state, payload) {
    state.eventEmployeesFilters.fndID = payload;
  },
  setEmployeesOrganizationIDFilter(state, payload) {
    state.eventEmployeesFilters.organizationID = payload;
  },
  setEmployeesRoleFilter(state, payload) {
    state.eventEmployeesFilters.role = payload;
  },
  resetEmployeesFilters(state) {
    state.eventEmployeesFilters = {
      role: undefined,
      organizationID: undefined,
      fndID: undefined,
    }
  },
  setNotificationPolicy(state, { type, policy }) {
    state.event.notifications_policies[type] = policy;
  }
};

export default mutations;
